import { makeUseAxios } from 'axios-hooks';

import apiClient from '../utils/apiClient';
import { v4 } from 'uuid';

export default makeUseAxios({
  axios: apiClient,
});

const trackingId = v4();

export const getHeader = () => ({
  'X-Mockable': 'false',
  'X-SourceSystem': 'CMS-SPA',
  'X-TrackingId': `${trackingId}-${v4().substring(0, 5)}`,
  'X-Api-Context': 'CMS',
  'Content-Type': 'application/JSON',
});
